import React, { useState, useEffect } from "react";
import { Typography, makeStyles } from "@material-ui/core";
import FinalScore from "./FinalScore";
import Answers from "./Answers";
import { useLocation } from "react-router-dom";
import { Button } from "@mui/material";
import { Print } from "@material-ui/icons";
import { useReactToPrint } from "react-to-print";

const useStyles = makeStyles((theme) => ({
  container: {
    height:'72vh',
     overflow:'scroll',
     scrollbarWidth:'none',
     scrollBehavior:'smooth'
  },
  headingMain: {
    width: "100%",
    background: "#4565B7",
    "& .MuiTypography-h3": {
      color: "#FFF",
      textAlign: "center",
      fontSize: "1.3rem",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "2.625rem",
      textTransform: "capitalize",
    },
  },
  pdfBtn: {
    background: "#00577B !important",
    color: "white !important",
    fontSize: "0.87rem !important",
    fontFamily: "Outfit !important",
    fontWeight: "600 !important",
    textTransform: "capitalize !important",
    padding: "0.6rem 0.9rem !important",
    "&:hover": {
      background: "#00577B !important",
      color: "white !important",
    },
  },
  pdfContainer: {
    display: "flex",
    justifyContent: "space-between",
    margin: "15px 10px 6px",
    gap:'20px',
    alignItems:'center'

  },
  pm:{
margin:0,
fontSize:'15px',
color:'black'
  },
   boxshadow5: {
    boxShadow: "-5px 1px 15px 0px rgba(0, 0, 0, 0.07)",
  },
   px1: {
    paddingLeft: "1rem !important",
    paddingRight: "1rem !important",
  },
  py0_5: {
    paddingTop: "0.5rem !important",
    paddingBottom: "0.5rem !important",
  },
  borderradius6px: {
    borderRadius: "6px  !important",
  },
  fontsize1: {
    fontSize: "0.9rem !important",
  },
  fontfamilyDMSans: {
    fontFamily: "DM Sans !important",
  },
  fw700: {
    fontWeight: "700 !important",
  },
   fw400: {
    fontWeight: "400 !important",
  },
  w30: {
    width: "100% !important",
    background:'white'
  },
  flowHidden:{
    overflow:'hidden',
    whiteSpace:'wrap'
  }
}));

function ExamScore() {
  const classes = useStyles();
  const location = useLocation();

  // const examResultData = JSON.parse(location.state?.examResult);

  let examResultData;
  try {
    examResultData = JSON.parse(location.state?.examResult);
  } catch (error) {
    console.error("Error parsing examResultData:", error);
  }

  const componentRef = React.useRef(null);

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
    document.getElementById("elementId").classList.remove("hide-print");
  }, []);

  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
    document.getElementById("elementId").classList.add("hide-print");

    return Promise.resolve();
  }, []);

  const printFn = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "AwesomeFileName",
    onAfterPrint: handleAfterPrint,
    onBeforePrint: handleBeforePrint,
  });

  return (
    <div id="pdf-container" ref={componentRef}>
      <div className={classes.headingMain}>
        <Typography variant="h3">Exam Sheet!</Typography>
      </div>
      <div className={[classes.pdfContainer]}>
        <div style={{display:'flex',gap:'15px', width:'80%', alignItems:'center'}}>
           <div className={`${classes.boxshadow5} ${classes.w30} ${classes.px1} ${classes.py0_5} ${classes.borderradius6px}`}>
                     <Typography
                       variant="h3"
                       gutterBottom
                       className={`${classes.fontsize1} ${classes.fontfamilyDMSans} ${classes.fw700}`}
                     >
                      Exam
                     </Typography>
                     
                     <Typography
                       variant="h3"
                       className={`${classes.fontsize1} ${classes.fontfamilyDMSans} ${classes.fw400} ${classes.flowHidden}`}
                     >
                      {examResultData.exam_name}
                     </Typography>
                   </div>
                   <div className={`${classes.boxshadow5} ${classes.w30} ${classes.px1} ${classes.py0_5} ${classes.borderradius6px}`}>
                     <Typography
                       variant="h3"
                       gutterBottom
                       className={`${classes.fontsize1} ${classes.fontfamilyDMSans} ${classes.fw700}`}
                     >
                      Name
                     </Typography>
                     
                     <Typography
                       variant="h3"
                       className={`${classes.fontsize1} ${classes.fontfamilyDMSans} ${classes.fw400}`}
                     >
                      {examResultData.learner_name}
                     </Typography>
                   </div>
                   <div className={`${classes.boxshadow5} ${classes.w30} ${classes.px1} ${classes.py0_5} ${classes.borderradius6px}`}>
                     <Typography
                       variant="h3"
                       gutterBottom
                       className={`${classes.fontsize1} ${classes.fontfamilyDMSans} ${classes.fw700}`}
                     >
                      Roll Number
                     </Typography>
                     
                     <Typography
                       variant="h3"
                       className={`${classes.fontsize1} ${classes.fontfamilyDMSans} ${classes.fw400}`}
                     >
                      {examResultData.roll_number}
                     </Typography>
                   </div>
         
        </div>
        <Button
          id="elementId"
          endIcon={<Print />}
          onClick={printFn}
          title="Print Results"
          size="large"
          className={[classes.pdfBtn]}
        >
          PDF
        </Button>
      </div>
          <div className={`${classes.container}`} >

      {examResultData && <FinalScore examResultData={examResultData} />}
      </div>
      {/* {examResultData && examResultData.result && (
        <Answers examResultData={examResultData} />
      )} */}
    </div>
  );
}

export default ExamScore;
